export default __webpack_public_path__ + "static/media/50_BottomLeftSquares_Left.7ceb0338.mp4";